import { render, staticRenderFns } from "./EmployeesSituationSubsidies.vue?vue&type=template&id=dd56f24c&scoped=true&"
import script from "./EmployeesSituationSubsidies.vue?vue&type=script&lang=js&"
export * from "./EmployeesSituationSubsidies.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesSituationSubsidies.vue?vue&type=style&index=0&id=dd56f24c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd56f24c",
  null
  
)

export default component.exports